import React, { useRef, useEffect } from 'react';
import KeynotesOverview from '../components/KeynotesOverview';
import './Pages.css';

const KIImpulse = () => {
  const heroRef = useRef<HTMLElement | null>(null);

  // Ensure hero overlaps header on mobile exactly like page-header
  useEffect(() => {
    const applyMobileHeroOffset = () => {
      if (!heroRef.current) return;
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      if (!isMobile) {
        heroRef.current.style.marginTop = '';
        heroRef.current.style.paddingTop = '';
        return;
      }
      const header = document.querySelector<HTMLElement>('.header-container');
      const headerHeight = header ? header.offsetHeight : 70;
      heroRef.current.style.marginTop = `-${headerHeight}px`;
      // Keep existing vertical padding but add headerHeight to top
      // Default mobile top padding similar to page-header (2rem)
      const baseTopPaddingRem = 2;
      const baseTopPaddingPx = baseTopPaddingRem * 16; // assume 16px root
      const computedTopPadding = headerHeight + baseTopPaddingPx;
      heroRef.current.style.paddingTop = `${computedTopPadding}px`;
    };

    applyMobileHeroOffset();
    window.addEventListener('resize', applyMobileHeroOffset, { passive: true });
    window.addEventListener('orientationchange', applyMobileHeroOffset, { passive: true } as any);
    return () => {
      window.removeEventListener('resize', applyMobileHeroOffset as any);
      window.removeEventListener('orientationchange', applyMobileHeroOffset as any);
    };
  }, []);

  return (
    <div className="page ki-impulse-page">
      {/* Hero Section - Same structure as KI-Werkstatt page */}
      <section
        ref={(el) => { heroRef.current = el; }}
        className="page-header ki-impulse-hero"
      >
        <div className="container">
          <div className="ki-impulse-hero-content">
            <h1 className="ki-impulse-hero-title">KI ERLEBEN</h1>
            <p className="ki-impulse-hero-subtitle">
              In Vorträgen mit technischen Demos
            </p>
          </div>
        </div>
      </section>
      
      <KeynotesOverview />
      
      <section className="cta-section" data-section="kiimpulse-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Gemeinsam für <span className="highlight-text">KI</span> begeistern.</h2>
            <p>Vereinbaren Sie ein unverbindliches Gespräch mit uns.</p>
            <a href="/kontakt" className="btn btn-secondary">Kontakt</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KIImpulse;
